export const BORDERED_CARD_STYLES = {
  root: {
    borderColor: 'var(--mantine-color-gray-5)'
  }
}
